import React, { useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { PushNotifications } from '@capacitor/push-notifications';
import { App as CapacitorApp } from '@capacitor/app';
import { ScreenOrientation } from '@capacitor/screen-orientation';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
/* Web / desktop layout (mobile & native unaffected) */
import './theme/web.css';
import VersionGate from './VersionGate';
import Tabs from "./Tabs";
import UpdatesAdmin from './pages/UpdatesAdmin';
import UpdatesConnect from './pages/UpdatesConnect';
import { Capacitor } from '@capacitor/core';

/* Ionic core + styles ... (your existing imports) */

setupIonicReact();

const App: React.FC = () => {
  // 🔔 Step 4: Register for Push Notifications
  useEffect(() => {
    if (Capacitor.getPlatform() !== "web") {
      const registerPush = async () => {
        console.log('Requesting Push Notification permission...');
  
        // Request permission from user
        const permission = await PushNotifications.requestPermissions();
  
        if (permission.receive === 'granted') {
          console.log('Permission granted ✅');
  
          // Listen for registration success
          PushNotifications.addListener('registration', (token) => {
            console.log('Hybrid FCM Token:', token.value);
            // 👉 Save this token to your Firestore or backend if needed
          });
  
          // Listen for registration errors
          PushNotifications.addListener('registrationError', (err) => {
            console.error('Hybrid Registration error:', err.error);
          });
  
          // Listen for push notifications received while app is open
          PushNotifications.addListener('pushNotificationReceived', (notification) => {
            console.log('Hybrid Notification received:', notification);
          });
  
          // Listen when user taps a notification
          PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
            console.log('Hybrid Notification action performed:', notification);
  
            const payload = notification.notification.data || notification.notification;
            // ✅ Save payload temporarily so Home.tsx can access it
            localStorage.setItem('latestNotification', JSON.stringify(payload));
  
            const title = notification.notification.title || "";
            const body = notification.notification.body || "";
        
            // Store notification content in localStorage
            localStorage.setItem('lastPushNotification', JSON.stringify({ title, body }));
  
            // ✅ Dispatch a custom event so Home.tsx can instantly react if it’s already open
            window.dispatchEvent(new CustomEvent('pushNotificationAction', { detail: { payload } }));
  
            // ✅ Navigate to Home tab
            window.location.href = '/tabs/home';
          });
  
          // Register with FCM
          await PushNotifications.register();
  
        } else {
          console.warn('Push notification permission not granted ❌');
        }
      };
  
      registerPush();
    }
  }, []);

  useEffect(() => {
    if (Capacitor.getPlatform() !== "web") {
      CapacitorApp.addListener('appUrlOpen', (data) => {
        console.log('App opened via deep link or notification:', data);
      });
    
      CapacitorApp.addListener('resume', async () => {
        const lastNotif = await PushNotifications.getDeliveredNotifications();
        console.log('Delivered notifications (resume):', lastNotif);
      });

      ScreenOrientation.lock({ orientation: 'portrait' });
    }
  }, []);

  return (
    <IonApp>
      <VersionGate /> {/* still runs globally */}
      <IonReactRouter>
        <IonRouterOutlet>
          <Route exact path="/updates/connect" component={UpdatesConnect} />
          <Route exact path="/updates/admin" component={UpdatesAdmin} />
          <Route path="/tabs" component={Tabs} />
          <Route exact path="/">
            <Redirect to="/tabs/home" />
          </Route>
        </IonRouterOutlet>
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
